export interface SessionTimeoutConfig {
  timeoutDurationMs: number;
  warningDurationMs: number;
  resetEvents: string[];
  showWarning: boolean;
}

export interface SessionTimeoutState {
  timeRemaining: number;
  isActive: boolean;
  showWarning: boolean;
  isExpired: boolean;
  lastActivity?: number;
}

export enum SessionTimeoutEvent {
  WARNING = "warning",
  EXPIRED = "expired",
  RESET = "reset",
}
